import { setCookie } from 'Functions/cookie'
import { calculateHeaderSize } from 'Functions/window'

const cookieMessage = document.querySelector('.js-cookie-message')
const infoMessage = document.querySelector('.js-info-message')

if (cookieMessage) {
    cookieMessage.classList.add('is-loaded')

    cookieMessage.querySelector('.js-cookie-message-close').addEventListener('click', event => {
        event.preventDefault()

        setCookie("cookies-allowed", 1, 365)

        cookieMessage.classList.remove('is-loaded')
    })
}

if (infoMessage) {
    for (const closeMessageEl of document.querySelectorAll('.js-info-message-close')) {
        closeMessageEl.addEventListener('click', (event) => {
            event.preventDefault()

            const infoMessageEL = closeMessageEl.closest('.js-info-message')
            const cookieKey = infoMessageEL.dataset.cookieKey || 'msg-text'
            const cookieValue = infoMessageEL.dataset.cookieValue
            setCookie(cookieKey, cookieValue, 1);

            infoMessageEL.style.display = 'none'

            requestAnimationFrame(calculateHeaderSize)
        })
    }
}
